import React, { useEffect } from "react";
import "./App.css";
import {
  About,
  Career,
  Contact,
  Head,
  Projects,
  Skills,
  Footer,
} from "./components";
import "./i18n";
import { useTranslation } from "react-i18next";
import { mainIcon } from "./assets/";

function App() {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    window.scrollTo(0, 0);
    window.history.scrollRestoration = "manual";
  }, []);

  useEffect(() => {
    document.title = "Jakub Michalski";

    const favicon = document.querySelector("link[rel='icon']");
    if (favicon) {
      favicon.href = mainIcon;
    } else {
      const newFavicon = document.createElement("link");
      newFavicon.rel = "icon";
      newFavicon.href = mainIcon;
      document.head.appendChild(newFavicon);
    }
  }, []);

  return (
    <>
      <Head></Head>
      <About></About>
      <Career></Career>
      <Skills></Skills>
      <Projects></Projects>
      <Contact></Contact>
      <Footer></Footer>
    </>
  );
}

export default App;
